import { EnvironmentConfig } from './environment.types';

function requireEnv(key: string): string {
  const value = process.env[key];
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

export const productionConfig: EnvironmentConfig = {
  API_URL: requireEnv('REACT_APP_API_URL'),
  AUTH_API_URL: requireEnv('REACT_APP_AUTH_URL'),
  AUTH_SEC_API_URL: requireEnv('REACT_APP_AUTH_SEC_URL'),
  LOGIN_API_URL: requireEnv('REACT_APP_LOGIN_URL'),
  LOCAL_RELAY_SERVER_URL: process.env.REACT_APP_LOCAL_RELAY_SERVER_URL || '',
  CLIENT_ID: requireEnv('REACT_APP_CLIENT_ID'),
  ENV: 'production',
  OPENAI_REALTIME_ENABLED: process.env.REACT_APP_OPENAI_REALTIME_ENABLED === 'true',
  OPENAI_REALTIME_API_KEY: process.env.REACT_APP_OPENAI_API_KEY || '',
  DEEPGRAM_REALTIME_ENABLED: process.env.REACT_APP_DEEPGRAM_REALTIME_ENABLED === 'true',
  TRANSCRIPT_SUMMARY_ENABLED: process.env.REACT_APP_TRANSCRIPT_SUMMARY_ENABLED === 'true',
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN || '',
  PRO_API_URL: requireEnv('REACT_APP_PRO_API_URL'),
  APP_NAME: process.env.REACT_APP_NAME || 'Anzu',
  APP_SUBTITLE: process.env.REACT_APP_SUBTITLE || 'AI Medical Assistant',
};
